/**
 * mobile-items.js
 */

import React from 'react';
import { useMediaQuery, List, Badge, Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import { UserContext } from 'contexts/user/user-context';
import { AuthContext } from 'contexts/auth/auth-context';
import { AppUtilityContext } from 'contexts/app-utility/app-utility-context';
import { LiveTrackingContext } from 'components/tracking/live-tracking/live-tracking-context';
import NotificationsContext from 'contexts/notifications/notifications.context';
import DropMenu from 'components/drop-menu';
import HelpMenu from '../app-bar/help-menu';
import Icon from 'components/icon';
import MenuItem from './menu-item';


const useStyles = makeStyles(theme => ({
  menu: {
    padding: theme.spacing(2),
  },
  badge: {
    fontSize: theme.typography.sizes[1],
    fontWeight: 600,
  },
}));


// menu base 
export default function MobileItems(props) {
  const classes = useStyles();
  const theme = useTheme();
  const sizeXS = useMediaQuery(theme.breakpoints.down('sm'));
  const { user, setRole } = React.useContext(UserContext);
  const { alertError } = React.useContext(AppUtilityContext);
  const { isActive: isTrackingActive } = React.useContext(LiveTrackingContext);
  const { unreadCount, setOpen } = React.useContext(NotificationsContext);
  const { logout } = React.useContext(AuthContext);
  const alertTitle = 'Action Unavailable';
  const alertText = `This action isn't allowed because you're currently creating a location track. To use this function, first return to the tracking interface and finish your active track.`;


  const notificationsClick = () => {
    setOpen(true);
    if (props.onSelect) {
      props.onSelect(null);
    }
  }


  const onReloadData = () => {
    window.location.reload();
  }


  const onChangeRole = (role) => {
    if (user.role.id !== role.id) {
      if (isTrackingActive) {
        alertError({
          title: alertTitle,
          text: alertText
        });
        return;
      }
      setRole(role);
    }
    if (props.onSelect) {
      props.onSelect(null);
    }
  }


  const onLogout = () => {
    if (isTrackingActive) {
      alertError({
        title: alertTitle,
        text: alertText
      });
      return;
    }
    logout();
  }


  return (
    <>
      {sizeXS &&
        <>
          <Divider />
          <List className={classes.menu}>
            <MenuItem
              icon={<Icon type="refresh" />}
              title="Reload Data"
              onClick={onReloadData}
            />

            <HelpMenu
              label={
                <div className='flex-hc' data-testid='role-container-mobile'>
                  <MenuItem
                    id="support-menu"
                    icon={<Icon type='help' />}
                    title="Support"
                    // onClick={() => {
                    //   props.onSelect(); // this will close the main menu drawer 
                    // }}
                  />
                  <Icon type='arrow-right' />
                </div>
              }
              onSelect={() => props.onSelect()}
              isInMobileContext={true}
            />

            {/* notifications menu item */}
            <MenuItem
              icon={
                <Badge
                  badgeContent={unreadCount}
                  color="secondary"
                  classes={{ badge: classes.badge }}
                  invisible={unreadCount === 0}
                >
                  <Icon type='notification' />
                </Badge>
              }
              title="Notifications"
              onClick={notificationsClick}
            />

            {/* role menu item */}
            <DropMenu
              id="change-role"
              label={(
                <div className='flex-hc' data-testid='role-container-mobile'>
                  <MenuItem
                    icon={<Icon type='role' />}
                    title={`Role (${user.role.name})`}
                  />
                  <Icon type='arrow-right' />
                </div>
              )}
              aria-label="change role menu"
              onSelect={onChangeRole}
              items={user.availableRoles.map(role => {
                return {
                  ...role,
                  key: role.id,
                  icon: role.name.toLowerCase(),
                  active: user.role.id === role.id,
                }
              })}
            />

            {/* logout menu item */}
            <MenuItem
              icon={<Icon type='logout' />}
              title="Logout"
              onClick={() => {
                props.onSelect(null);
                onLogout();
              }}
            />

          </List>
        </>}
    </>
  );
}